import React from 'react'

import ModalStyle from '../../context/ModalStyle'
import { Box, Modal } from '@mui/material'

const DefaultModal = ({show,HandleClose,content}) => {
  return (
<>


                  <Modal
  open={show}
  onClose={HandleClose}
>
  <Box sx={ModalStyle} className="col-lg-4 col-sm-12 col-12 rounded border-none ">
  <div className="modal-content">
                  
{content}
                  
                      </div>
  </Box>
</Modal>
</>
  )
}

export default DefaultModal

